import { cva, type VariantProps } from 'class-variance-authority';
import type { ComponentProps, ReactNode } from 'react';

import { cn } from '../lib/cn';

export const calloutVariants = cva(
  'flex gap-3 rounded-lg border px-4 py-3 text-sm [&>svg]:mt-0.5 [&>svg]:size-4 [&>svg]:shrink-0',
  {
    variants: {
      tone: {
        info: 'border-primary/25 bg-primary/8 text-foreground [&>svg]:text-primary',
        success: 'border-success/30 bg-success/10 text-foreground [&>svg]:text-success',
        warning: 'border-warning/35 bg-warning/10 text-foreground [&>svg]:text-warning',
        destructive:
          'border-destructive/30 bg-destructive/8 text-foreground [&>svg]:text-destructive',
      },
    },
    defaultVariants: { tone: 'info' },
  },
);

export interface CalloutProps
  extends Omit<ComponentProps<'div'>, 'title'>, VariantProps<typeof calloutVariants> {
  icon?: ReactNode;
  title?: ReactNode;
}

/** Aviso en línea (banner de estado, advertencia, confirmación). `role="status"` salvo errores. */
export function Callout({ tone, icon, title, className, children, ...props }: CalloutProps) {
  return (
    <div
      role={tone === 'destructive' ? 'alert' : 'status'}
      className={cn(calloutVariants({ tone }), className)}
      {...props}
    >
      {icon}
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        {title ? <p className="font-medium">{title}</p> : null}
        {children ? <div className="text-muted-foreground">{children}</div> : null}
      </div>
    </div>
  );
}
